let activePixelId = null;
let scriptInjected = false;
let pageViewSentForPixel = null;

const ACTION_TO_META_EVENT = {
  ver_produto: "ViewContent",
  buscar: "Search",
  filtrar: "ViewCategory",
  clicar_whatsapp: "Contact",
  clicar_instagram: "Contact",
  clicar_facebook: "Contact",
  clicar_tiktok: "Contact",
  clicar_twitter: "Contact",
  clicar_geolocalizacao: "Contact",
  clicar_link: "Contact",
};

function getWindow() {
  if (typeof window === "undefined") return null;
  return window;
}

function ensureFbqScript() {
  const w = getWindow();
  if (!w || scriptInjected || w.fbq) return;

  scriptInjected = true;
  ((f, b, e, v, n, t, s) => {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(w, w.document, "script", "https://connect.facebook.net/en_US/fbevents.js");
}

function getCookie(name) {
  const w = getWindow();
  if (!w) return null;
  const match = w.document.cookie.match(
    new RegExp(`(^| )${name.replace(/([.$?*|{}()[\\/+^])/g, "\\$1")}=([^;]+)`)
  );
  return match ? decodeURIComponent(match[2]) : null;
}

function getOrBuildFbc() {
  const w = getWindow();
  if (!w) return null;

  const existing = getCookie("_fbc");
  if (existing) return existing;

  const params = new URLSearchParams(w.location.search || "");
  const fbclid = params.get("fbclid");
  if (!fbclid) return null;

  return `fb.1.${Date.now()}.${fbclid}`;
}

function getMetaBrowserIdentifiers() {
  return {
    fbp: getCookie("_fbp"),
    fbc: getOrBuildFbc(),
  };
}

function createMetaEventId(prefix = "vt") {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

function initializeMetaPixel(pixelId) {
  const w = getWindow();
  const normalized = String(pixelId || "").trim();
  if (!w || !normalized) return false;

  ensureFbqScript();

  if (!w.fbq) return false;

  if (activePixelId !== normalized) {
    w.fbq("init", normalized);
    activePixelId = normalized;
    pageViewSentForPixel = null;
  }

  return true;
}

function sendMetaPageView({ eventId = null } = {}) {
  const w = getWindow();
  if (!w?.fbq || !activePixelId) return false;
  if (pageViewSentForPixel === activePixelId) return false;

  const resolvedEventId = eventId || createMetaEventId("pv");
  w.fbq("track", "PageView", {}, { eventID: resolvedEventId });
  pageViewSentForPixel = activePixelId;
  return true;
}

function trackMetaAction({ tipo_acao, produto_id = null, termo_busca = null, eventId = null }) {
  const w = getWindow();
  if (!w?.fbq || !activePixelId || !tipo_acao) return null;

  const eventName = ACTION_TO_META_EVENT[tipo_acao];
  if (!eventName) return null;

  const resolvedEventId = eventId || createMetaEventId(tipo_acao);
  const payload = {};

  if (tipo_acao === "ver_produto" && produto_id) {
    payload.content_ids = [produto_id];
    payload.content_type = "product";
  }

  if (tipo_acao === "buscar" && termo_busca) {
    payload.search_string = termo_busca;
  }

  w.fbq("track", eventName, payload, { eventID: resolvedEventId });
  return { eventName, eventId: resolvedEventId };
}

export {
  initializeMetaPixel,
  sendMetaPageView,
  trackMetaAction,
  getMetaBrowserIdentifiers,
  createMetaEventId,
};
